// src/v3/documents/document-success.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var DocumentSuccessIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "DocumentSuccessIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M20.2 7.4L15 2.2C14.9 2.1 14.7 2 14.5 2H5.5C4.7 2 4 2.7 4 3.5V20C4 20.8 4.7 21.5 5.5 21.5H19C19.8 21.5 20.5 20.8 20.5 20V8C20.5 7.8 20.4 7.6 20.2 7.4ZM15.2 4.5L17.9 7.2H15.2V4.5ZM19 19.9H5.4V3.5H13.6V8C13.6 8.4 13.9 8.8 14.4 8.8H18.9V19.9H19ZM16.1 11C16.4 11.3 16.4 11.8 16.1 12.1L11.6 16.6C11.3 16.9 10.8 16.9 10.5 16.6L8.3 14.3C8 14 8 13.5 8.3 13.2C8.6 12.9 9.1 12.9 9.4 13.2L11.1 14.9L15.1 10.9C15.3 10.7 15.8 10.7 16.1 11Z"
  }
) });

export {
  DocumentSuccessIcon
};
